import svg from 'src/images/custom-icons/ai-copilot.icon.svg';

const aiCopilotSideBarTokens = {
    iconData: svg,
    iconWidth: 24,
    iconHeight: 24,
    iconTitle: 'AI Copilot'
};

export default aiCopilotSideBarTokens;
